import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { DynamicDetailComponent } from '../../../dynamic-entity/components/dynamic-detail/dynamic-detail.component';
import { Observable } from 'rxjs/Observable';

import { TemplateService } from './template.service';
import { environment } from '../../../../environments/environment';

import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent extends DynamicDetailComponent implements OnInit, AfterViewInit {

  private mappingForm: FormGroup;
  public mainForm: FormGroup;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected location: Location,
    private fb: FormBuilder, protected toastr: ToastrService, private http: Http) {

    super(baseservice, metadataservice, router, route, location, toastr);
  }

  ngOnInit() {
    super.ngOnInit();

    this.mainForm = this.fb.group({
      //Id: null,
      Designation: [null, Validators.required],
      Customers: null,
      Inactive: [false, Validators.required]
    });

    this.mappingForm = this.fb.group({
      Sheet: [null, Validators.required],
      HeaderRow: [null, Validators.required],
      Vessel: null,
      PortOfLoading: null,
      PortOfDischarge: null,
      ProductCode: [null, Validators.required],
      ProductName: null,
      Lot: null,
      Zone: null,
      ProductType: null,
      NetWeight: null,
      GrossWeight: null,
      NetSize: this.fb.group({ Length: null, Width: null, Thickness: null }),
      GrossSize: this.fb.group({ Length: null, Width: null, Thickness: null }),
      Quality: null,
      PlateCount: null,
      SoldTo: null,
      ShipTo: null,
      Container: null,
      Obs: null
    });

  }

  ngAfterViewInit() {
    const previousMainValId = this.mainForm.valid;
    const previousMappingValId = this.mappingForm.valid;

    this.mainForm.valueChanges.subscribe(() => this.setCanSave(previousMainValId, previousMappingValId));
    this.mappingForm.valueChanges.subscribe(() => this.setCanSave(previousMainValId, previousMappingValId));
    this.status.canSave = previousMainValId && previousMappingValId;
  }

  protected setCanSave(previousMainValId, previousMappingValId) {
    if (this.mainForm.valid !== previousMainValId || previousMappingValId !== this.mappingForm.valid) {
      previousMainValId = this.mainForm.valid;
      previousMappingValId = this.mappingForm.valid;
      this.status.canSave = previousMainValId && previousMappingValId;
    }
  }

  protected setValues(values) {
    this.item = values;
    this.status.canDelete = true;
    this.mainForm.patchValue(this.item);
    this.mappingForm.patchValue(JSON.parse(this.item.Mapping));
  }

  public save(event) {

    const formModel = this.mainForm.value;
    this.item = Object.assign(this.item, this.mainForm.value);
    this.item.Mapping = JSON.stringify(this.mappingForm.value);

    this.baseservice.save(this.item)
      .subscribe(return_value => {
        this.toastr.success('Gravação efectuada com sucesso', '', { timeOut: 3000 });
        if (return_value !== true) {
          this.item = return_value;
        }
        //this.location.back();
      },
      error => {
        this.error = error;
        console.log('Error saving:' + error);
      });
  }

  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.http
      .get(API_URL + '/Customers?search=' + text)
      .map(data => data.json().map(item => item));

  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/config/templates/template.component.ts